module.exports = __webpack_public_path__ + "img/nb_1.e53c9d31.png";